module.exports = __webpack_public_path__ + "static/media/easa.85d64f90.png";